import { createApp } from 'vue';
import CalendarTimeslotPicker from '@components-molecules/CalendarTimeslotPicker.vue';
import { translationMixin } from '@elements/translation';
import { hideSubmitLoader, showSubmitLoader } from '@atoms/spinner';
import { TwigFormValidator } from '@tools/twig-form/validator';

export const contactSchedule = () => {
  const component = {
    components: {
      CalendarTimeslotPicker,
    },
    mixins: [ translationMixin ],
    data() {
      return {
        disableImpersonateSchedule: true,
        impersonateSchedule: null,
        errorContent: null,
      };
    },
    mounted() {
      this.initValidateForm();
    },
    watch: {
      disableImpersonateSchedule(disabled) {
        if (disabled) {
          this.resetImpersonateOptions();
        }
      },
    },
    methods: {
      /**
       * @param {array} selectedSlots
       */
      updateLabelNextButton(selectedSlots = []) {
        const buttonToUpdateText = document.querySelectorAll('#schedule_deal_save span')[0];
        const buttonToUpdate = document.getElementById('schedule_deal_save');
        if (buttonToUpdate && buttonToUpdateText) {
          buttonToUpdateText.innerHTML = this.trans('calendar.button.next', { nbrSlotSelected: selectedSlots.length });
          buttonToUpdate.disabled = selectedSlots.length <= 0;
        }
      },
      slotsUpdated(times) {
        this.disableImpersonateSchedule = times.length !== 1;
      },
      resetImpersonateOptions() {
        this.impersonateSchedule = null;
        if (this.errorContent) {
          this.errorContent.remove();
          this.errorContent = null;
        }
      },
      initValidateForm() {
        const formSelector = 'form[name="schedule_deal"]';
        const inputSelector = `${formSelector} input[name="schedule_deal[impersonate_schedule]"]`;
        const validatorRules = {
          'schedule_deal[impersonate_schedule]': () => document.querySelector(`${inputSelector}:checked`)?.value !== undefined,
        };

        const validatorMessages = {
          'schedule_deal[impersonate_schedule]': 'required',
        };

        const submitButton = document.querySelector('button[type="submit"]');
        const validator = new TwigFormValidator({
          formSelector,
          rules: validatorRules,
          messages: validatorMessages,
          onSubmit: (event) => {
            showSubmitLoader(submitButton);

            // if form is disabled, we don't need to validate it
            return this.disableImpersonateSchedule;
          },
          onFailure: (event, message) => {
            const impersonateSchedule = document.querySelector('#schedule_deal_impersonate_schedule');
            if (!this.errorContent) {
              impersonateSchedule.insertAdjacentHTML('afterend', `<label class="error">${message['schedule_deal[impersonate_schedule]']}</label>`);
              this.errorContent = impersonateSchedule.nextElementSibling;
            }
            hideSubmitLoader(submitButton);
          },
        });
        validator.init();
      },
    },
  };

  return createApp(component).mount('.contact-schedule');
};
